import { render, staticRenderFns } from "./SimpleOptionArticleForm.vue?vue&type=template&id=98fe9144"
import script from "./SimpleOptionArticleForm.vue?vue&type=script&lang=ts"
export * from "./SimpleOptionArticleForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports